import { createFileRoute } from "@tanstack/react-router";
import { Navigate, useParams } from "../../../../scaffolding/router-api";

export const Route = createFileRoute("/_auth/_frame/clients/$companyId/")({
  component: ClientDetailIndexRedirect,
});

function ClientDetailIndexRedirect() {
  const { companyId } = useParams({ from: "/_auth/_frame/clients/$companyId/" });

  return <Navigate to="/clients/$companyId/projects" params={{ companyId }} replace />;
}
